"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var systemSetting = _interopRequireWildcard(require("@/api/systemSetting"));
var _permission = require("@/utils/permission");
var _editPrintReceipt = _interopRequireDefault(require("./editPrintReceipt.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'printReceipt',
  filters: {
    printTypeFilter: function printTypeFilter(status) {
      var statusMap = {
        0: '易联云',
        1: '飞蛾云'
      };
      return statusMap[status];
    }
  },
  components: {
    editPrintReceipt: _editPrintReceipt.default
  },
  data: function data() {
    return {
      editPrintReceiptConfig: {
        dialogVisible: false,
        edit: false,
        // false=新增 true=编辑
        editData: {}
      },
      tableData: {
        data: [],
        total: 0
      },
      tableDataPram: {
        page: 1,
        limit: 20,
        loading: false
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['merchant:admin:print:list'])) this.getDataList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    closeDialog: function closeDialog() {
      this.editPrintReceiptConfig.dialogVisible = false;
    },
    // 添加
    handleAddPrintReceipt: function handleAddPrintReceipt() {
      this.editPrintReceiptConfig.dialogVisible = true;
      this.editPrintReceiptConfig.edit = false;
    },
    // 分页
    pageChange: function pageChange(e) {
      this.tableDataPram.page = e;
      this.getDataList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.tableDataPram.limit = e;
      this.getDataList();
    },
    // 数据列表
    getDataList: function getDataList() {
      var _this = this;
      this.tableDataPram.loading = true;
      systemSetting.merchantPrintList(this.tableDataPram).then(function (data) {
        _this.tableDataPram.loading = false;
        _this.tableData = data;
      });
    },
    // 编辑
    bindEdit: function bindEdit(item) {
      this.editPrintReceiptConfig.editData = item;
      this.editPrintReceiptConfig.dialogVisible = true;
      this.editPrintReceiptConfig.edit = true;
    },
    // 删除
    bindDelete: function bindDelete(param) {
      var _this2 = this;
      this.$modalSure('删除当前数据?').then(function () {
        if (_this2.tableData.list.length === 1) {
          _this2.tableDataPram.page = _this2.tableDataPram.page - 1;
        }
        systemSetting.merchantPrintDelete(param.id).then(function (data) {
          _this2.$message.success('删除成功');
          _this2.getList();
        });
      });
    },
    getList: function getList() {
      this.getDataList();
    },
    handleOnchangeIsShow: function handleOnchangeIsShow(row) {
      var _this3 = this;
      systemSetting.merchantPrintStatus(row).then(function (data) {
        _this3.$message.success('更新状态成功');
        _this3.getDataList();
      });
    },
    handleEditPrintDialogUnVisible: function handleEditPrintDialogUnVisible() {
      this.getDataList();
      this.editPrintReceiptConfig.editData = {};
      this.editPrintReceiptConfig.dialogVisible = false;
    }
  }
};